// extracted by mini-css-extract-plugin
module.exports = {"flex":"style__flex__lG+Zx","modalFooter":"style__modalFooter__7a4AW"};